module.exports = __webpack_public_path__ + "img/department_icon6.8a429b6b.png";